<template>
  <table
    class="min-w-full divide-y divide-gray-300 dark:rounded-md dark:border dark:border-white dark:bg-slate-700"
  >
    <thead class="bg-gray-50 dark:bg-slate-700">
      <tr>
        <th
          scope="col"
          class="capitalize-first py-2.5 pr-3 pl-4 text-left text-sm font-semibold text-gray-900 sm:pl-6 dark:text-white"
        >
          {{ $t('attributes.reference') }}
        </th>
        <th
          scope="col"
          class="capitalize-first px-3 py-2.5 text-left text-sm font-semibold text-gray-900 sm:pl-6 dark:text-white"
        >
          {{ $t('attributes.type') }}
        </th>
        <th
          scope="col"
          class="capitalize-first py-2.5 pr-3 pl-4 text-right text-sm font-semibold text-gray-900 sm:pl-6 dark:text-white"
        >
          {{ $t('attributes.total_tvac') }}
        </th>
      </tr>
    </thead>
    <tbody class="divide-y divide-gray-200 bg-white">
      <template v-for="invoice in invoices" :key="invoice.id">
        <tr>
          <td
            class="py-2 pr-3 pl-4 text-sm font-medium whitespace-nowrap text-gray-900 sm:pl-6"
          >
            {{ invoice.reference }}
          </td>
          <td
            class="px-3 py-2 text-left text-sm whitespace-nowrap text-gray-500"
          >
            {{ $t(`enums.invoicing.docTypes.${invoice.doc_type}`) }}
          </td>
          <td
            class="py-2 pr-4 pl-3 text-right text-sm whitespace-nowrap text-gray-500"
          >
            {{ $h.formatCurrency(invoice.total_tvac, invoice.currency) }}
          </td>
        </tr>
      </template>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'ShowInvoicesModalTable',
  props: {
    invoices: {
      type: Array,
      required: true
    }
  }
}
</script>
